import { useEffect, useRef } from "react";

import { useDispatchDrawers } from "contexts/drawers";

import { registerCoreDrawers } from "./registerDrawers";

/**
 * Hook to register core drawers on mount.
 * Should be called once at the app level.
 */
export function useDrawerRegistration() {
    const dispatch = useDispatchDrawers();
    const hasRegistered = useRef(false);

    useEffect(() => {
        if (!hasRegistered.current) {
            registerCoreDrawers(dispatch);
            hasRegistered.current = true;
        }
    }, [dispatch]);
}
